// import lossClient from "auth/lossClientInterceptor";
import { lossClient } from "api";

const PersonalCustomerService = {};

PersonalCustomerService.getProspectCustomerList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/konsumendariProspect/konsumenprospect?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&name=" +
      userInput.name +
      "&idNumber=" +
      userInput.idNumber +
      "&birthDate=" +
      userInput.birthDate +
      "&motherName=" +
      userInput.motherName +
      "&prospectid=" +
      userInput.prospectid,
    method: "get",
  });
};

PersonalCustomerService.getProspectCustomerByIdList = function (userInput) {
  return lossClient({
    url:
      "/konsumendariProspect/konsumenprospect?pageSize=10&pageIndex=0&prospectId=" +
      userInput.prospectId,
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/PersonalCustomer/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid,
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerJobList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/PersonalCustomerJob/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerFinancialList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex || 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/PersonalCustomerFinancial/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerSpouseList = function (userInput) {
  var userInputIndex = userInput.pageIndex && 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/PersonalCustomerSpouse/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerEmergencyList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex && 0;
  
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/personalcustomercontactemergency/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerFamilyList = function (userInput) {
  var userInputIndex = userInput.pageIndex && 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // ...existing code...
  return lossClient({
    url:
      "/PersonalCustomerFamily/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getPersonalCustomerLoanList = function (userInput) {
  var userInputIndex = userInput.pageIndex && 0;
  // ...existing code...
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/PersonalCustomerLoan/items?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code,
    // "&customerid=" +
    // userInput.customerid +
    method: "get",
  });
};

PersonalCustomerService.getCalculateWorkPeriod = function (userInput) {
  // ...existing code...

  return lossClient({
    url:
      "/personalcustomerjob/calculateworkingperiod?startDate=" +
      userInput.startDate,
    method: "get",
  });
};

 

PersonalCustomerService.postPersonalCustomer = function (data) {
  return lossClient({
    url: "/PersonalCustomer/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerJob = function (data) {
  return lossClient({
    url: "/PersonalCustomerJob/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerFinancial = function (data) {
  return lossClient({
    url: "/PersonalCustomerFinancial/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerSpouse = function (data) {
  return lossClient({
    url: "/PersonalCustomerSpouse/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerEmergency = function (data) {
  return lossClient({
    url: "/PersonalCustomerContactEmergency/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerFamily = function (data) {
  return lossClient({
    url: "/PersonalCustomerFamily/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.postPersonalCustomerLoan = function (data) {
  return lossClient({
    url: "/PersonalCustomerLoan/add",
    method: "post",
    data: data,
  });
};

PersonalCustomerService.updatePersonalCustomer = function (data) {
  const { id, ...requestBody } = data;
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomer/Edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerJob = function (data) {
  const { id, ...requestBody } = data;
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerJob/edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerFinancial = function (data) {
  const { id, ...requestBody } = data;
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerFinancial/edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerSpouse = function (data) {
  console.log("🚀 ~ data:", data);
  const { id, ...requestBody } = data;
  console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerSpouse/Edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerEmergency = function (data) {
  console.log("🚀 ~ data:", data);
  const { id, ...requestBody } = data;
  console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerContactEmergency/Edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerFamily = function (data) {
  console.log("🚀 ~ data:", data);
  const { Id, ...requestBody } = data;
  console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerFamily/edit",
    method: "put",
    headers: {
      "x-requestId": data.Id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.updatePersonalCustomerLoan = function (data) {
  console.log("🚀 ~ data:", data);
  const { Id, ...requestBody } = data;
  console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/PersonalCustomerLoan/edit",
    method: "put",
    headers: {
      "x-requestid": data.Id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.deletePersonalCustomer = function (data) {
  console.log(
    "🚀 ~ PersonalCustomerService.deletePersonalCustomer ~ data:",
    data
  );
  const { id, ...requestBody } = data;
  console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/PersonalCustomer/Delete",
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

PersonalCustomerService.deletePersonalCustomerFamily = function (data) {
  console.log(
    "🚀 ~ PersonalCustomerFamilyService.deletePersonalCustomerFamily ~ data:",
    data
  );
  // const { id, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/PersonalCustomerFamily/delete",
    method: "delete",
    headers: {
      "x-requestId": data,
    },
    data: {},
  });
};

PersonalCustomerService.deletePersonalCustomerLoan = function (data) {
  console.log(
    "🚀 ~ PersonalCustomerLoanService.deletePersonalCustomerLoan ~ data:",
    data
  );
  // const { id, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/PersonalCustomerLoan/delete",
    method: "delete",
    headers: {
      "x-requestid": data,
    },
    data: {},
  });
};

export default PersonalCustomerService;
